var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3331bf",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 490 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.5,269.5V103.7h-19.8v165.8h-69.8V167.3H295v102.2h-36.9l-65.2-147h-32.4L151.2,61H82.4L73,122.5H41.7v147H0L36.5,429    h334.6L490,269.5H404.5z M100.1,80.8h33.4l6.3,41.7H93.9L100.1,80.8z M62.6,143.4h116.7l20.9,46.9H62.6V143.4z M209.1,210.1    l26.5,59.4h-173v-59.4H209.1z M361.8,408.1H53.2L25,289.3h425.3L361.8,408.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 77.2,
    y: 318.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 131.4,
    y: 318.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 185.6,
    y: 318.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 239.8,
    y: 318.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 294,
    y: 318.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.9,
    x: 348.2,
    y: 318.5,
    height: 19.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.13973372ead4e68f1238159bfc3c0450.svg";
export { ForwardRef as ReactComponent };